import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import { useEffect, useState } from 'react';
import { useSelector } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import ReactMarkdown from 'react-markdown';
import { NavLink } from "react-router-dom";

const Producteurs = (props) => {

    const [producteurs, setProducteurs] = useState([]);
    const [filtre, setFiltre] = useState([]);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/producteurs`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setProducteurs(res);
            });
    }, []);

    const handleChange = (event) => {
        event.preventDefault();
        const { value } = event.target;
        setFiltre(value);
    };

    const handleFiltre = (event) => {
        event.preventDefault();
        fetch(`${URL_COURTJUS_BACK}/producteurs/${filtre}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setProducteurs(res);
            });
    };

    function handleSubmit(event) {
        event.preventDefault();
    }

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }

    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}
            <h3>Nos producteurs</h3>
            <section className="nav-admin">
                <form method="POST" id="formFiltre" className='form-filtre' onSubmit={handleFiltre}>
                    <input type="text" name="filtre" id="filtre" value={filtre} onChange={handleChange} />
                    <NavLink aria-label="Filtrer" title="Filtrer" onClick={handleFiltre}><img name={`Filtrer`} className={'btn-articles'} src="img/search.png" width={'26px'} height={'26px'} alt="Filtrer" /></NavLink>
                </form>
            </section>
            <NavLink className="nav-link text-plus" to="../articles" aria-label="leurs Produits" title="leurs Produits"><img src="img/leursarticles.png" className="btn-articles" alt="leurs Produits" style={{marginTop:"10px",width:"140px"}} /></NavLink>
            <div className="saut"></div>
            {producteurs.map((q, i) =>
                <section className="section-prods" key={i}>
                    <img src={`/img/pictures/${q.uPhotoProfil}`} alt="1er article" className="float-prods" />
                    <article className="section-prods-fiche section-demie">
                        <h2>{q.uStructure}</h2>
                        <p className="p-impact">  {q.uProduction}</p>
                        <h3 title={`${q.uPrenom} ${q.uNom}`}>{q.uPrenom} {q.uNom}</h3>
                        <p>{q.uMailPro && q.uMailPro}{q.uMailPro === "" && q.uMail}</p>
                        <p>{q.uTel}</p>
                        <p>{q.uAdr_CP} {q.uAdr_Ville}</p>
                    </article>
                    <article className="section-prods-infos">
                        <ReactMarkdown>{q.uInfosComp.replace(/\n/g, '  \n')}</ReactMarkdown>
                    </article>
                </section>
            )}
            <div className="main-down"></div>

        </main>

    )
}

export default Producteurs;